import { FunctionComponent } from 'react'
import Checkbox from '@mui/material/Checkbox'
import { dismissPopover } from 'services/OverlayService'

const Selector: FunctionComponent<SelectorProps> = ({ aol, atBottom, id, selected, title, type, expanded }) => (selected === undefined)
  ? null
  : (
    <div className='relative'>
      <input
        type='checkbox'
        name={id}
        id={`${id}/${atBottom}`}
        checked={expanded}
        data-action='expand'
        data-path={id}
        data-type='content'
        data-value={+!expanded}
        readOnly
      />
      <Checkbox
        onClick={(e) => {
          dismissPopover(e.target)
          e.stopPropagation()
        }}
        checked={selected !== 0}
        inputProps={{
          'data-action': 'select',
          'data-path': id,
          'data-type': type,
          'data-value': selected !== 0 ? 0 : 1,
          readOnly: true
        } as any}
        data-event-category='Accordion'
        data-event-action={selected !== 0 ? 'Deselect' : 'Select'}
        data-event-label={title}
        {...(aol !== undefined && {
          'data-event-aol': Array.isArray(aol) ? aol.join(',') : aol
        })}
        data-help-item='accordionselector'
        data-help-position='left'
      />
    </div>
    )

interface SelectorProps {
  aol?: string | string[]
  atBottom: number
  id: string
  selected: number
  title: string
  type: string
  expanded: boolean
}

export default Selector
